module.exports = __webpack_public_path__ + "img/diversity.8471de8.webp";